module.exports = __webpack_public_path__ + "static/01-f6d67c1f78ab1a10ae8dbbe9a7a4f8b7.png";